module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am591-37f5d450117210e6f443681dcbc756ab.jpg";